export interface AuthUser {
  username: string;
  email?: string;
  isAuthenticated: boolean;
}

export class AuthService {
  async signInWithHostedUI(): Promise<void> {
    const hostedUIUrl = 'https://eu-north-1n1u5rgw9s.auth.eu-north-1.amazoncognito.com/login/continue?client_id=2rih2rss5um4427r20962kp9lp&redirect_uri=https%3A%2F%2Fwww.allsaintsthirsk.org.uk%2Fauth%2Fcallback&response_type=code&scope=email+openid+phone';
    window.location.href = hostedUIUrl;
  }

  async signOut(): Promise<void> {
    localStorage.removeItem('auth_user');
    localStorage.removeItem('auth_token');
    window.location.href = '/';
  }

  async getCurrentUser(): Promise<AuthUser | null> {
    console.log('🔍 getCurrentUser called');
    console.log('Current pathname:', window.location.pathname);
    console.log('Current search:', window.location.search);
    
    // Check if we have auth code in URL (callback scenario)
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    console.log('Auth code from URL:', code);
    
    if (code && window.location.pathname === '/auth/callback') {
      console.log('✅ Found auth code on callback page, storing user');
      // Store a simple auth state
      const user = {
        username: 'admin',
        email: 'admin@allsaintsthirsk.org.uk',
        isAuthenticated: true
      };
      localStorage.setItem('auth_user', JSON.stringify(user));
      localStorage.setItem('auth_token', code);
      console.log('✅ User stored in localStorage:', user);
      return user;
    }
    
    // Check localStorage for existing auth
    const storedUser = localStorage.getItem('auth_user');
    console.log('Stored user from localStorage:', storedUser);
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      console.log('✅ Returning stored user:', parsedUser);
      return parsedUser;
    }
    
    console.log('❌ No auth found, returning null');
    return null;
  }

  async getAuthToken(): Promise<string | null> {
    return localStorage.getItem('auth_token');
  }
}

export const authService = new AuthService();